import { render } from "./MasterBoardPriorityTasksModal.vue?vue&type=template&id=3bbf2131&scoped=true"
import script from "./MasterBoardPriorityTasksModal.vue?vue&type=script&lang=js"
export * from "./MasterBoardPriorityTasksModal.vue?vue&type=script&lang=js"

import "./MasterBoardPriorityTasksModal.vue?vue&type=style&index=0&id=3bbf2131&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3bbf2131"

export default script